var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"driver-status d-inline-flex align-items-center",attrs:{"title":_vm.statusName}},[_c('span',{staticClass:"driver-status__dot rounded-circle mr-2",style:(_vm.dotStyle)}),_vm._v(" "+_vm._s(_vm.statusName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }